import React, { useState, useEffect } from 'react';
import { Link, navigate } from "gatsby"

import Layout from "components/layout"
import Seo from "components/seo"
import "styles/dashboard.style.css"
import DashboardContent from "components/medangle/DashboardContent"

function Dashboard(props){
    return(
        
        <Layout>
            <Seo title="Dashboard" />
            <div>
              
            <DashboardContent/>
            </div>
        </Layout>
      
        

    );
}
export default Dashboard